import * as React from 'react';
import { OrderedMap } from 'immutable';
import { SelectOption } from 'components/inputs/BaseSelect';
import AppStoreContext from 'contexts/AppStoreContext';
import { useTranslator } from '@bluebeam/react-i18n';
import { Discipline } from 'records/Discipline';
import { DisciplineDesignator } from 'records/SheetsSettings';

const useDisciplineSelect = (): {
  disciplineOptions: OrderedMap<string, SelectOption<string | null>>;
  projectDisciplines: OrderedMap<DisciplineDesignator, Discipline>;
} => {
  const { state: appState } = React.useContext(AppStoreContext);
  const {
    settings: { sheets: sheetSettings },
  } = appState;
  const { translate } = useTranslator(['disciplineFilterSection']);

  const disciplineOptions = React.useMemo(() => {
    return sheetSettings.disciplines.reduce(
      (acc, discipline) =>
        acc.set(discipline.designator, {
          value: discipline.designator,
          label: translate(
            `disciplineFilterSection:disciplines.${discipline.description}`,
            {
              defaultValue: discipline.description,
            }
          ),
        }),
      OrderedMap<string, SelectOption<string | null>>()
    );
  }, [translate, sheetSettings.disciplines]);

  return { disciplineOptions, projectDisciplines: sheetSettings.disciplines };
};

export { useDisciplineSelect };
